<style scoped>

</style>
<template>
  <div>
    <div :class="{'color-error': expense_group.del || expense_group.is_refund}">
      {{ expense_group.uid }}
    </div>
    <div>
      <span
        v-if="expense_group.del"
        :class="{'color-error': expense_group.del}"
      >
        [已废弃]
      </span>
      <span
        v-if="expense_group.is_refund"
        :class="{'color-error': expense_group.is_refund}"
      >
        [银行已退款]
      </span>
      <span
        v-if="should_set_bank"
        :class="{'color-error': should_set_bank}"
      >
        [未设置付款银行]
      </span>
      <span
        v-if="expense_group && expense_group.advance_id"
      >
        [冲预支]
      </span>
      <a
        v-if="expense_group.receipt"
        class="link"
        :href="$util.receiptUrl(expense_group.receipt.filename)"
        target="_blank"
      >
        [银行回单]
      </a>
      <span
        v-if="expense_group&&expense_group.return_expense_group_id"
        class="color-error"
      >
        [退款单]
      </span>
    </div>
    <div
      v-if="show_advance_status"
    >
      <span
        :class="advance_class"
      >
        {{ advance_status }}
      </span>
    </div>
    <div v-if="nodeStatus&&nodeStatus.length">
      <Tag 
        v-for="(item,index) in nodeStatus"
        :key="index"
        :color="item.color"
        type="border"
        :fade="false"
      >
        {{ item.text }}
      </Tag>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      expense_group: {
        type: Object
      },
      nodeStatus: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      is_finish() {
        return this.expense_group.status === 9 || (this.expense_group.user_flow && this.expense_group.user_flow.is_finish)
      },
      show_advance_status() {
        return this.expense_group.payment_type === 2 && !this.expense_group.is_refund && !this.expense_group.return_expense_group_id && this.is_finish;
      },
      advance_class() {
        return this.expense_group.expense_group ? 'color-success' : 'color-error';
      },
      advance_status() {
        return this.expense_group.expense_group ? '已冲账' : '待冲账';
      },
      should_set_bank() {
        return !this.expense_group.del && this.expense_group.paid_at && !this.expense_group.expense_payment_bank_id && ![5, 6, 7].includes(this.expense_group.payment_type);
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
